// extracted by mini-css-extract-plugin
export var initialblock = "ParagraphDogSizes-module--initialblock--e1ad3";
export var inner = "ParagraphDogSizes-module--inner--6c4dc";
export var secondaryblock = "ParagraphDogSizes-module--secondaryblock--86b30 ParagraphDogSizes-module--initialblock--e1ad3";
export var sizeblock = "ParagraphDogSizes-module--sizeblock--0a1d9";
export var sizeblockcarouselcontainer = "ParagraphDogSizes-module--sizeblockcarouselcontainer--f2490";
export var sizeblockdetails = "ParagraphDogSizes-module--sizeblockdetails--2d870";
export var title = "ParagraphDogSizes-module--title--060ce";